// extracted by mini-css-extract-plugin
export default {"table-container":"JemdGrnx42WCI2zERBMMyQ==","lastRow":"Cv7-PEV+kzHp46xabDS0CQ==","longText":"c+KPyq-0q34tB3vwmtWe4Q=="};